import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import TransferScheduleCreateForm from '~/containers/transferScheduleCreate/transferScheduleCreate';

export class TransferScheduleCreatePage extends Component {
  render() {
    const cancelButton = (
      <Link to={`/settings/transfers`}>
        <Button color="secondary">Cancel</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar
          back="/settings/transfers"
          backText="TransferSchedules"
          title="Add transfer schedule"
          button={cancelButton}
        />
        <TransferScheduleCreateForm />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(TransferScheduleCreatePage));



// WEBPACK FOOTER //
// ./src/pages/transferScheduleCreate/transferScheduleCreate.jsx